export const flattenTree = <T>(root: T, key: string) => {
  let flatten = [Object.assign({}, root)];
  
  if (root[key] && root[key].length > 0) {
    return flatten.concat(root[key]
      .map((child)=>flattenTree(child, key))
      .reduce((a, b)=>a.concat(b), [])
    );
  }

  return flatten;
}